"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClickGame = void 0;
var useClickGame_1 = require("./useClickGame");
Object.defineProperty(exports, "useClickGame", { enumerable: true, get: function () { return useClickGame_1.useClickGame; } });
